/**
 * PDP: strip Excel-pasted table borders from product descriptions and keep copy in the white tile.
 */
(function () {
  const SELECTORS = [
    '.product-details rte-formatter.cc-pdp-desc-tile',
    '.product-details .group-block:has(.buy-buttons-block) > .group-block-content > rte-formatter.rte',
  ];

  /**
   * Excel exports wrap copy in <table><td height="…" style="height:…pt"> — unwrap to plain text.
   * @param {HTMLElement} root
   */
  function unwrapExcelTables(root) {
    root.querySelectorAll('table').forEach((table) => {
      const text = table.innerText.replace(/\s+/g, ' ').trim();
      const replacement = document.createElement('div');
      replacement.className = 'cc-pdp-desc-plain';
      if (text) {
        const paragraph = document.createElement('p');
        paragraph.textContent = text;
        replacement.append(paragraph);
      }
      table.replaceWith(replacement);
    });

    root.querySelectorAll('.rte-table-wrapper').forEach((wrapper) => {
      if (wrapper.childElementCount === 0) {
        wrapper.remove();
        return;
      }
      if (wrapper.children.length === 1) {
        wrapper.replaceWith(...wrapper.childNodes);
      }
    });
  }

  /**
   * @param {HTMLElement} root
   */
  function sanitizeDescription(root) {
    root.style.setProperty('overflow', 'visible', 'important');
    root.style.setProperty('max-height', 'none', 'important');
    root.style.setProperty('height', 'auto', 'important');

    root.querySelectorAll('*').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      node.style.setProperty('overflow', 'visible', 'important');
      node.style.setProperty('max-height', 'none', 'important');
      node.style.setProperty('height', 'auto', 'important');
      node.removeAttribute('height');
    });

    root.querySelectorAll('table, tbody, thead, tfoot, tr, td, th, [class*="xl"]').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      node.style.setProperty('border', 'none', 'important');
      node.style.setProperty('border-top', 'none', 'important');
      node.style.setProperty('border-right', 'none', 'important');
      node.style.setProperty('border-bottom', 'none', 'important');
      node.style.setProperty('border-left', 'none', 'important');
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('background-color', 'transparent', 'important');
      node.style.removeProperty('width');
      node.style.removeProperty('height');
      node.removeAttribute('height');
    });
  }

  function init() {
    const seen = new Set();
    for (const selector of SELECTORS) {
      document.querySelectorAll(selector).forEach((root) => {
        if (seen.has(root)) return;
        seen.add(root);
        unwrapExcelTables(root);
        sanitizeDescription(root);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
